import { render, staticRenderFns } from "./SurveyModel.vue?vue&type=template&id=a1422d16&scoped=true"
import script from "./SurveyModel.vue?vue&type=script&lang=js"
export * from "./SurveyModel.vue?vue&type=script&lang=js"
import style0 from "./SurveyModel.vue?vue&type=style&index=0&id=a1422d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1422d16",
  null
  
)

export default component.exports